import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';
import { validateDates } from 'utils/formatTime';

//
import API from 'restApi';
import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  profiles: [],
  profile: null,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },

  filters: {
    profilecode: '',
    profilelabel: '',
    demdelete: false,
    functions: [],
    lastUpdateFrom: null,
    lastUpdateTo: null,
    sort_column_name: 'profilecode',
    sort_type: 'ASC'
  },

};

const slice = createSlice({
  name: 'profiles',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;

    },

    // GET Users
    getProfileSuccess(state, action) {
      const { profile } = action.payload;
      state.isLoading = false;
      state.profile = profile;
      state.error = null;

    },
    resetProfile(state) {
      state.profile = initialState.user;

    },

    // GET Profiles
    getProfilesSuccess(state, action) {
      const { profiles, navig } = action.payload;
      state.error = null;
      state.isLoading = false;
      state.profiles = profiles;
      state.navig = navig;
    },

    //  SORT & FILTER Profiles
    sortByProfiles(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER Profiles
    paginationProfiles(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    sortProfiles(state, action) {
      state.filters = { ...state.filters, sort_type: action.payload.orderColumn, sort_column_name: action.payload.sortColumn };
    },
    filterProfiles(state, action) {
      state.filters = action.payload;
    },
    resetProfiles(state) {
      state.profiles = initialState.profiles;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  paginationProfiles,
  filterProfiles,
  resetProfiles,
  hasError,
  resetProfile,
  sortProfiles
} = slice.actions;

// ----------------------------------------------------------------------

export function getProfiles() {
  const { profile: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const start = new Date(filters.lastUpdateFrom).getTime();
      const end = new Date(filters.lastUpdateTo).getTime();
      const errors = validateDates({ start, end });
      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      // Fixer lastUpdateTo à 23h59
      const lastUpdateTo = filters.lastUpdateTo ? new Date(new Date(filters.lastUpdateTo).setHours(23,59,59)).toISOString() : null;

      const criteres = {
        ...filters,
        functions: filters.functions.map((item) => item.code),
        demdelete: filters.demdelete === true ? true : '',
        lastUpdateTo,
      };
      const response = await axios.post(API.path, {
        criteres,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },

        action: ACTIONS.SEARCHPROFILE
      });

      const { data } = response;
      dispatch(slice.actions.getProfilesSuccess(data));

      if (data.profiles.length === 0)
        throw new Error('NO_RESULTS');

    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}

export function getProfile({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADPROFILE,
        profilecode: code
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getProfileSuccess({ profile: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function testProfileCodeIsValid(profilecode) {
  const { data: { isValid } } = await axios.post(API.path, {
    action: ACTIONS.ISPROFILECODEVALID,
    profilecode
  });
  return isValid;
}



